const aiAds = {
    state: {
        showDrawer: false, // 控制是否显示AI广告助手抽屉
        aiCurrentPage: 1, // 当前在第几个步骤 1-2-3
        aiModel: 1, // 1单任务 、 2批量任务
        currentInfo:{
            automationId: '',
            programmeId: '',
            serviceId: '',
            customerId: '',
        }, // 当前第三页获取详情时需要的参数
    },
    mutations: {
        setShowDrawer:(state)=>{
            state.showDrawer = !state.showDrawer;
        },
        setCurrentPage:(state,value)=>{
            state.aiCurrentPage = value;
        },
        setModel:(state, value)=>{
            state.aiModel = value;
        },
        setCurrentInfo:(state,value)=>{
            state.currentInfo = value;
        }
    }
}

export default aiAds;